import React from 'react';
import TextBase from './TextBase';
import { TText } from './types';

const Small = ({ as = 'span', color, strong = false, ...rest }: TText) => (
  <TextBase {...rest} as={as} kind={`body-small${strong ? '-strong' : ''}`} color={color} />
);

export default Small;
